import React, { useEffect, useReducer, useRef, useState } from 'react'
import { get, post } from '../../config/fetch'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Accordion, Tooltip } from '@material-ui/core'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputLabel from '@material-ui/core/InputLabel'
import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import IconButton from '@material-ui/core/IconButton'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import TableHead from '@material-ui/core/TableHead'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import {
    TOKEN_GET_BASE_STATION,
    TOKEN_GET_DEVICES_BRAND,
    TOKEN_GET_DEVICES_LIST, TOKEN_GET_KPIS,
    TOKEN_INCIDENTS_BY_DATE, TOKEN_SEARCH_KPIS,
} from '../../constants/constants'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import SearchIcon from '@material-ui/icons/Search'
import TablePagination from '@material-ui/core/TablePagination'
import AlertWrapper from '../common/alert'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import { red } from '@material-ui/core/colors'
import { getKpiColorByNetworkIndicator } from '../heatmap/kpiUtils'
import { PopupKpi } from '../common/popup'

const drawerWidth = 240
const MILLISECONDS = 60000;
const MILLISECONDS_HOURS = 3600000;
const MINUTES = 60;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        background: 'black'
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    map: {
        position: 'relative',
        width: '98%',
        margin: '1em auto',
        padding: '1em',
        height: 'calc(100% - 2em)',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        magin: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#06171E',
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fixedHeight: {
        height: 600,
    },
    fixedHeight2: {
        height: 135,
    },
    fixedHeight3: {
        height: 450,
    },
}))

const columns = [
    { id: 'msisdn', disablePadding: false, label: 'MSISDN' },
    { id: 'createdAt', disablePadding: false, label: 'Date' },
    { id: 'battery', disablePadding: false, label: 'Battery' },
    { id: 'type', disablePadding: false, label: 'Type Network' },
    { id: 'ci', disablePadding: false, label: 'CI' },
    { id: 'tac', disablePadding: false, label: 'TAC' },
    { id: 'cid', disablePadding: false, label: 'CID' },
    { id: 'lac', disablePadding: false, label: 'LAC' },
    { id: 'mcc', disablePadding: false, label: 'MCC' },
    { id: 'mnc', disablePadding: false, label: 'MNC' },
    { id: 'mobileNetworkOperator', disablePadding: false, label: 'Operator' },
    { id: 'pci', disablePadding: false, label: 'PCI' },
    { id: 'bandwidth', disablePadding: false, label: 'Bandwidth' },
    { id: 'earfcn', disablePadding: false, label: 'Earfcn' },
    { id: 'asuLevel', disablePadding: false, label: 'AsuLevel' },
    { id: 'rsrp', disablePadding: false, label: 'RSRP' },
    { id: 'rsrq', disablePadding: false, label: 'RSRQ' },
    { id: 'rssi', disablePadding: false, label: 'RSSI' },
    { id: 'rssnr', disablePadding: false, label: 'RSSNR' },
    { id: 'cqi', disablePadding: false, label: 'CQI' },
    { id: 'lat-lng', disablePadding: false, label: 'Location' },
    //{ id: 'longitud', disablePadding: false, label: 'Longitud' },
]

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align || 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map(el => el[0])
}

const defaultCenter = {
    lng: -99.160558,
    lat: 19.425869,
}

export default function SearchKpis() {
    const classes = useStyles()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        kpis: []
    });
    const [stateSearch, setStateSearch] = useReducer((s, a) => ({ ...s, ...a }), {
        input: '',
        loading: false,
    });
    const mapContainer = useRef()
    const [map, setMap] = useState(null)
    
    const today = new Date()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
    const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2)
    const fixedHeightPaper3 = clsx(classes.paper, classes.fixedHeight)

    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('calories')
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    
    const [msisdn, setMsisdn] = useState('')
    const [viewError, setViewError] = useState(false)
    const [startDate, setStartDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0),
    )
    const [endDate, setEndDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59),
    )
    
    const [isLoading, setLoading] = useState(true)
    const [isLoadingByDate, setLoadingByDate] = useState(true)
    const [visiblePopover, setVisiblePopover] = useState(true)
    const [coordinates, setCoordinates] = useState([])
    
    /*
    useEffect(() => {
        //setLoading(true)
        fetchDevicesBrand();
    });

    useEffect(() => {
        fetchDevicesList();
    });
    */

    useEffect( async () => {
        let map = null
        setLoading(true)
        map = initMap(defaultCenter.lat, defaultCenter.lng)
        setLoading(false)
        return () => map.remove()
    }, []);
    
    const handleDate = async date => {
        setStartDate(date)
        const newEndDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            endDate.getHours(),
            endDate.getMinutes(),
        )
        setEndDate(newEndDate)
    }

    const initMap = (lat, lng) => {
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/dark-v9',
            center: [lng, lat],
            zoom: 15,
        })
        /*
        map.on('moveend', () => {
            setValue('latitude', map.getCenter().lat.toFixed(6))
            setValue('longitude', map.getCenter().lng.toFixed(6))
        })*/

        map.on('load', () => {
            setMap(map)
            //renderCircle(lat, lng, map)
        })

        return map
    }

    const findKpis = async () => {
        try {
            const startDateISO = new Date(startDate).toISOString()
            const endDateISO = new Date(endDate).toISOString()
            const url = `/searchKpis?code=${TOKEN_SEARCH_KPIS}&msisdn=${msisdn}&startDate=${startDateISO}&endDate=${endDateISO}`;

            const { data: kpis } = await get(url)

            return kpis
        } catch (e) {
            throw new Error(e)
        }
    }
    
    const handleChangeMsisdn = (event) => {
        setMsisdn(event.target.value)
    }

    const handleStartTime = date => {
        setStartDate(date)
    }

    const handleEndTime = date => {
        setEndDate(date)
    }
    
    const handleFilter = () => {
        setViewError(false)
        if (!msisdn) {
            setViewError(true)
            return;
        }

        setStateSearch({
            ...state,
            loading: true,
        })
        findKpis()
            .then(response => {
                renderKpis(defaultCenter.lng, defaultCenter.lat, map, response);

                setStateSearch({
                    ...state,
                    loading: false,
                })
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    kpis: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }

    const handleViewMap = () => {
        window.location.href = '/heatmap?lng=' + coordinates[0] + '&lat=' + coordinates[1] + '&startDate=' + startDate + '&endDate=' + endDate
    }

    const handleChangeAccordion = () => {
        setVisiblePopover(!visiblePopover)
    }

    const renderKpis = async (
        lng,
        lat,
        map,
        kpis
    ) => {
        try {
            // new markers array
            let newMarkersKpi = []
            let newConnectionsKpi = []

            //const kpis = await fetchKpis(lng, lat, radius, startDate, endDate, deviceList)
            // OCTO-5
            //const newBaseStations = await fetchBaseStations(lng, lat, radius)
            //setBaseStations(newBaseStations)
            //hideLoadingKpi(map)

            let coordinates;
            // render new kpi markers
            kpis.forEach(kpi => {
                if (kpi.location) {
                    const markerKpi = {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: kpi.location.coordinates,
                        },
                        properties: {
                            connectivity: kpi.connectivity,
                            color: 'blue',
                            //description: PopupKpi(kpi),
                        },
                    }
                    coordinates = kpi.location.coordinates;

                    //renderMarkerKpi(kpi, map)
                    newMarkersKpi.push(markerKpi)
                }
            })

            //create Map source of kpis
            map.addSource('kpi', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: newMarkersKpi,
                },
            })

            // create layer to source of lines connection
            map.addLayer({
                id: 'kpi-circle',
                type: 'circle',
                source: `kpi`,
                paint: {
                    'circle-stroke-color': ['get', 'color'],
                    'circle-color': ['get', 'color'],
                    'circle-stroke-width': 1,
                },
            })

            map.flyTo({
                center: [Number(coordinates[0]), Number(coordinates[1])],
            })
            
            setCoordinates(coordinates)



            // Create a popup
            let popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
            })

            // Show popup when the mouse is over the kpi layer.
            /*
            map.on('mouseenter', 'kpi-circle', function (e) {
                map.getCanvas().style.cursor = 'pointer'

                var coordinates = e.features[0].geometry.coordinates.slice()
                var description = e.features[0].properties.description

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                }

                popup.setLngLat(coordinates).setHTML(description).addTo(map)
            })

            map.on('mouseleave', 'kpi-circle', function () {
                map.getCanvas().style.cursor = ''
                popup.remove()
            })
            */
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: '1em' }}
                    >
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                                <Accordion expanded={visiblePopover} onChange={handleChangeAccordion}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel-header"
                                    >
                                        <Typography>Filters</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <InputLabel shrink id="msisdn-label">
                                                MSISDN
                                            </InputLabel>
                                            <TextField
                                                fullWidth
                                                size="large"
                                                id="msisdn"
                                                onChange={handleChangeMsisdn}
                                                value={msisdn}
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardDatePicker
                                                        id="date-picker-dialog"
                                                        label="Filter date"
                                                        format="MM/dd/yyyy"
                                                        value={startDate}
                                                        onChange={handleDate}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardTimePicker
                                                        id="start-time-picker"
                                                        label="Start time"
                                                        value={startDate}
                                                        onChange={handleStartTime}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change time',
                                                        }}
                                                        keyboardIcon={<AccessTimeIcon />}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <AccordionDetails className={classes}>
                                                    <KeyboardTimePicker
                                                        id="end-time-picker"
                                                        label="End time"
                                                        value={endDate}
                                                        onChange={handleEndTime}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change time',
                                                        }}
                                                        keyboardIcon={<AccessTimeIcon />}
                                                    />
                                                </AccordionDetails>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Button size="small" color="primary" onClick={handleFilter}>
                                                Search
                                            </Button>
                                            {
                                                state.kpis && state.kpis.length > 0 ?
                                                    <Button size="small" color="primary" onClick={handleViewMap}>
                                                        Map
                                                    </Button>
                                                    : <></>
                                            }
                                            {
                                                viewError ? <div style={{color: '#FF0000'}}>Enter MSISDN</div> : <></>
                                            }
                                        </Grid>

                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={8}
                        xl={8}
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: '1em' }}>
                        <Grid container spacing={3}>
                            {
                                stateSearch.loading ?
                                    <Grid container justify = "center">
                                        <CircularProgress />
                                    </Grid>
                                    :
                                    <>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Paper className={fixedHeightPaper3}>

                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            size={'medium'}
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                numSelected={selected.length}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                //onSelectAllClick={handleSelectAllClick}
                                                                //onRequestSort={handleRequestSort}
                                                                rowCount={state.kpis.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(state.kpis, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        return (
                                                                            <TableRow tabIndex={-1} key={row.id}>
                                                                                <TableCell>{row.msisdn || '-'}</TableCell>
                                                                                <TableCell>{row.createdAt || '-'}</TableCell>
                                                                                <TableCell>{row.battery ? row.battery + '%' : '-'}</TableCell>
                                                                                {
                                                                                    row.connectivity ? 
                                                                                    <>
                                                                                        <TableCell>{row.connectivity.type || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.ci || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.tac || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.cid || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.lac || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.mcc || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.mnc || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.mobileNetworkOperator || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.pci || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.bandwidth || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.cell.earfcn || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.asuLevel || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.rsrp || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.rsrq || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.rssi || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.rssnr || '-'}</TableCell>
                                                                                        <TableCell>{row.connectivity.signal.cqi || '-'}</TableCell>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                    </>
                                                                                }
                                                                                {
                                                                                    row.location ?
                                                                                        <TableCell>
                                                                                            {row.location.coordinates[1]},{' '}
                                                                                            {row.location.coordinates[0]}
                                                                                        </TableCell>
                                                                                        :
                                                                                        <TableCell>{'-'}</TableCell>
                                                                                }
                                                                            </TableRow>
                                                                        )
                                                                    })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </>
                            }
                        </Grid>
                    </Grid>
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={3}
                        xl={3}
                        container
                        direction="column"
                        justify="flex-end"
                        alignItems="flex-end"
                        style={{ marginTop: '1em' }}>
                        <Paper elevation={3} className={classes.map} style={{
                            width: '95%',
                            margin: '1em 0',
                            padding: '1em',
                            height: '600px',
                            overflowY: 'auto',
                        }}>
                            <div className="map-container" ref={mapContainer} />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
